import {guestRequest} from './guestApi.js';
import {waitForPushRevocation} from './pushRevocation.js';
import {offlineShellState} from './offlineShell.js';
export type PushPreferences={visits:boolean;community:boolean;patches:boolean;project_work?:boolean};
export const emptyPushPreferences:PushPreferences={visits:false,community:false,patches:false,project_work:false};
const key='sonata-push-device-v1';
export const devicePushId=()=>{let id=localStorage.getItem(key);if(!id){id=crypto.randomUUID();localStorage.setItem(key,id);}return id;};
const applicationKey=(key:string)=>Uint8Array.from(atob(key.replace(/-/g,'+').replace(/_/g,'/')),c=>c.charCodeAt(0));
export const isInstalled=()=>window.matchMedia('(display-mode: standalone)').matches||(navigator as Navigator&{standalone?:boolean}).standalone===true;
export const pushSupported=()=>window.isSecureContext&&'serviceWorker' in navigator&&'PushManager' in window&&'Notification' in window;
export async function enablePush(publicKey:string,preferences:PushPreferences){
 if(offlineShellState()!=='ready')throw new Error('Update & restart the offline app before enabling notifications.');
 // Called only from the user's button click; invoke the permission prompt
 // before awaiting any network/worker operation to preserve iOS activation.
 const permission=await Notification.requestPermission();
 if(permission!=='granted')throw new Error('Notifications were not allowed. You can change this in your phone’s notification settings.');
 await waitForPushRevocation();
 const registration=await navigator.serviceWorker.ready;
 let subscription=await registration.pushManager.getSubscription();
 if(subscription&&subscription.options.applicationServerKey){
  const existing=new Uint8Array(subscription.options.applicationServerKey),expected=applicationKey(publicKey);
  if(existing.length!==expected.length||existing.some((v,i)=>v!==expected[i])){await subscription.unsubscribe();subscription=null;}
 }
 subscription=subscription||await registration.pushManager.subscribe({userVisibleOnly:true,applicationServerKey:applicationKey(publicKey)});
 try{return await guestRequest<{subscription_id:string;preferences:PushPreferences}>('/push/subscriptions','POST',{subscription_id:devicePushId(),subscription:subscription.toJSON(),preferences});}
 catch(e){await subscription.unsubscribe().catch(()=>false);throw e;}
}
export async function disablePush(){
 const id=devicePushId();
 const registration=await navigator.serviceWorker.ready;
 const subscription=await registration.pushManager.getSubscription();
 // Server revocation must succeed before saying this device is disabled.
 await guestRequest(`/push/subscriptions/${id}`,'DELETE');
 await subscription?.unsubscribe();
}
